import React from 'react';

var _path;

var SvgTransferWithinShopifyMajor = function SvgTransferWithinShopifyMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.202 9.801 4.07 6.47 6.152A1 1 0 0 0 6 7v2h2V7.554l5-3.125 5 3.125V18H8v-3H6v3.5A1.5 1.5 0 0 0 7.5 20h11a1.5 1.5 0 0 0 1.5-1.5V7a1 1 0 0 0-.47-.848l-6-3.75a1.003 1.003 0 0 0-1.06 0l-.807.505L7.555.168a1 1 0 0 0-1.11 0l-6 4A1.001 1.001 0 0 0 0 5v13h2V5.535l5-3.333zM5 13h6.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L11.586 11H5a1 1 0 0 0 0 2z"
  })));
};

export { SvgTransferWithinShopifyMajor as S };
